// extracted by mini-css-extract-plugin
export default {"promo_wrapper":"iY","disabled":"jY","spinner":"kY","codes":"lY","item":"mY","remove":"nY","promo":"oY","apply":"pY"};
    if(module.hot) {
      // 1711394579966
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  